import { useEventLogging } from '@innovamat/event-logging';
import { useState } from 'react';

type UseRequestHomeAccessModalReturn = {
  isModalOpen: boolean;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  handleContactAdvisor: () => void;
};

function useRequestHomeAccessModal(): UseRequestHomeAccessModalReturn {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { setEventData } = useEventLogging();

  const handleOpenModal = (): void => {
    setIsModalOpen(true);
  };

  const handleCloseModal = (): void => {
    setIsModalOpen(false);
  };

  const handleContactAdvisor = (): void => {
    setEventData('sys_advisor_email_click', {});
    handleCloseModal();
  };

  return {
    isModalOpen,
    handleOpenModal,
    handleCloseModal,
    handleContactAdvisor,
  };
}

export { useRequestHomeAccessModal };
